export default __webpack_public_path__ + "static/media/pantalla3.ab185e53.png";